
export class Util {

  public static fileFieldName(fieldName: string): string {
    return `${fieldName}_file_`;
  }
  public static complexFieldName(fieldName: string): string {
    return `@${fieldName}`;
  }

  public static toDatetime(dateTime: string): Date {
    return new Date(dateTime);
  }

  public static objectAssign(target: any, source: any): any {
    for (const key of Object.keys(source)) {
      const value = source[key];
      let valueTarget = target[key];
      if (Array.isArray(value) || Array.isArray(valueTarget)) {
        if (!Array.isArray(valueTarget)) {
          valueTarget = [];
          target[key] = valueTarget;
        }
        valueTarget.length = 0;
        if (Array.isArray(value) && value.length > 0) {
          value.forEach(i => {
            valueTarget.push(i);
          });
        }
      } else {
        target[key] = value;
      }
    }

    for (const key of Object.keys(target)) {
      if (source[key] === undefined) {
        const valueTarget = target[key];
        if (Array.isArray(valueTarget)) {
          valueTarget.length = 0;
        } else {
          if (key !== '_options_') {
            target[key] = undefined;
          } else {
            // target[key] = {};
          }
        }
      }
    }
    return target;
  }

  public static stringFormat(input: string, ...args: any[]): string {
    for (let i = 0; i < args.length; i++) {
      input = input.replace('{' + i + '}', args[i]);
    }
    return input;
  }

  public static numberFormat(x: number, decimal: number = null): string {
    if (x === null || x === undefined ) {
      return '';
    }

    if (decimal === null || decimal === undefined) {
      return x.toString();
    }

    const parts = x.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (decimal > 0 && parts.length === 2) {
      parts[1] = parts[1].substr(0, decimal);
    }
    return parts.join('.');
  }

  public static expandTreeListValues(list: any[], root= true): {[key: string]: any}[] {
    if (!list) {
      return null;
    }
    const ret: {[key: string]: any}[] = [];
    list.forEach(item => {
      ret.push({text: item.text, value: item.value});
      if (item.items && item.items.length > 0) {
        const children = Util.expandTreeListValues(item.items, false);
        children.forEach(child => {
          ret.push(child);
        });
      }
    });

    if (root) {
      // console.log('expandTreeListValues');
      // console.log(ret);
    }
    return ret;
  }

  public static toKendoListValues(list: any[][], caller = null): {[key: string]: any}[] {
    if (!list) {
      return null;
    }

    const ret: {[key: string]: any}[] = [];
    list.forEach(rec => {
      const item = {text: rec[1], value: rec[0]};
      for (let i = 2; i < rec.length; i++) {
        item['extra' + (i - 1)] = rec[i];
      }
      ret.push(item);
    });

    if (caller) {
      console.log(caller + ' call toKendoListValues');
    }
    return ret;
  }
}
